export default "__VITE_ASSET__eAz2qhbE__"